import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
const ScrollableRow = ({ children, gap }) => {
    return (_jsx("div", { className: "scrollable-row", style: gap ? { gap } : undefined, children: children }));
};
export default ScrollableRow;
